import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function MarzahnHellersdorf() {
  return (
    <LocationPageTemplate
      page={{
        location: "Marzahn-Hellersdorf",
        locationSlug: "marzahn-hellersdorf",
        keyword: "Haushaltsauflösung Marzahn-Hellersdorf",
        metaTitle:
          "Haushaltsauflösung Marzahn-Hellersdorf | Festpreis & Termin in 48h",
        metaDesc:
          "Professionelle Haushaltsauflösung in Berlin Marzahn-Hellersdorf. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Marzahn-Hellersdorf – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909b7524813c707c7a87a7.jpg",
        localIntro: (
          <>
            <p>
              Der Bezirk Marzahn-Hellersdorf im Osten Berlins ist bekannt für
              seine Großwohnsiedlungen mit vielen Hochhäusern und Plattenbauten,
              aber auch für ausgedehnte Einfamilienhausgebiete in Biesdorf,
              Kaulsdorf und Mahlsdorf. Diese Zweiteilung bringt unterschiedliche
              Herausforderungen bei der Entrümpelung mit sich.
            </p>
            <p>
              In den Wohnkomplexen in Marzahn oder Hellersdorf sind Aufzüge oft
              vorhanden, was den Transport erleichtert, jedoch müssen die Wege
              zu den Parkplätzen oft gut geplant werden, um lange Laufwege zu
              vermeiden. In den Siedlungsgebieten im Süden des Bezirks
              (Deutschlands größtes zusammenhängendes Einfamilienhausgebiet)
              geht es hingegen häufig um die Räumung kompletter Häuser inklusive
              Keller und Garten.
            </p>
            <p>
              Unser Team ist mit den Gegebenheiten in Marzahn-Hellersdorf
              bestens vertraut und sorgt für einen reibungslosen Ablauf, egal in
              welchem Ortsteil sich das Objekt befindet.
            </p>
          </>
        ),
        trustText:
          "Ob eine Wohnung in einem Hochhaus in Marzahn oder ein Einfamilienhaus in Biesdorf – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen zuverlässig zur Seite.",
        trustQuote:
          "Die Räumung der Wohnung in Hellersdorf ging super schnell. Das Team war pünktlich und hat alles sauber hinterlassen.",
        challengesText: (
          <>
            <p>
              In den Großwohnsiedlungen stimmen wir uns bei Bedarf mit
              Hausverwaltungen ab, um Aufzüge effizient nutzen zu können, ohne
              die Mitbewohner übermäßig zu beeinträchtigen. Kurze Wege sind hier
              entscheidend für eine schnelle Räumung.
            </p>
            <p>
              Bei Hausauflösungen in Kaulsdorf oder Mahlsdorf sorgen wir für
              ausreichend Transportfahrzeuge, um auch große Mengen an Sperrmüll
              aus Kellern oder Garagen zügig abzutransportieren und
              umweltgerecht auf den Berliner Recyclinghöfen zu entsorgen.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Sehr professionell und freundlich. Die Entrümpelung unseres Hauses in Biesdorf verlief absolut reibungslos.",
            author: "Familie aus Biesdorf",
          },
          {
            text: "Toller Service zum fairen Festpreis. Ich musste mich um nichts kümmern.",
            author: "Kunde aus Marzahn",
          },
          {
            text: "Schnelle Terminvergabe und sehr saubere Arbeit. Die Wohnung war komplett besenrein.",
            author: "Kundin aus Hellersdorf",
          },
        ],
        neighbors: [
          { name: "Märkisch Oderland", slug: "maerkisch-oderland" },
          { name: "Treptow Köpenick", slug: "treptow-koepenick" },
          { name: "Berlin", slug: "berlin" },
        ],
        faqs: [
          {
            q: "Kommen Sie auch für kleinere Entrümpelungen nach Marzahn?",
            a: "Ja, wir übernehmen auch Teilentrümpelungen, zum Beispiel nur die Räumung eines Kellers oder einzelner Zimmer.",
          },
          {
            q: "Gibt es einen Aufschlag für Wohnungen in höheren Stockwerken?",
            a: "Nein, wir vereinbaren einen Festpreis nach der kostenlosen Besichtigung. Dieser Preis ist bindend, unabhängig vom Stockwerk.",
          },
          {
            q: "Wie schnell können Sie mit der Räumung beginnen?",
            a: "Oft können wir nach der Besichtigung schon innerhalb weniger Tage mit der eigentlichen Entrümpelung starten.",
          },
          {
            q: "Was passiert mit noch brauchbaren Möbeln?",
            a: "Gut erhaltene Stücke können wir im Rahmen der Wertanrechnung mit den Kosten verrechnen oder an soziale Einrichtungen weitergeben.",
          },
        ],
      }}
    />
  );
}
